<button
  class="tp-icon-btn export-widget__btn"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  [class.export-widget__btn--active]="menuTrigger.menuOpen"
>
  <tp-icon name="icons/export" class="pointer" isResponsive="true"></tp-icon>
</button>

<mat-menu #menu="matMenu" class="export-widget__menu">
  <button
    mat-menu-item
    *ngIf="configByType[fileType.pdf].visible"
    (click)="exportData(fileType.pdf)"
  >
    PDF
  </button>
  <button
    mat-menu-item
    *ngIf="configByType[fileType.xls].visible"
    (click)="exportData(fileType.xls)"
  >
    XLS
  </button>
</mat-menu>
